import BaseService from "./base.service";
import http from "../http-common";
import { checkEnterpriseId } from "@helpers/_functions";

class TimeClockLimitService extends BaseService {
  constructor() {
    super("timeClockLimit");
  }

  getByEnterprise() {
    const enterpriseId = checkEnterpriseId();
    return http.get(`${this.path}/getByEnterprise/${enterpriseId}`);
  }

  upsert(data) {
    const enterpriseId = checkEnterpriseId();
    return http.post(`${this.path}/upsert`, data, { params: { enterpriseId } });
  }
}

export default new TimeClockLimitService();